/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProjectFileDto } from '../../models/backend-project-file-dto';
import { BackendProjectFileRequestDto } from '../../models/backend-project-file-request-dto';

export interface ProjectsProjectFilesUpdate$Params {
  id: number;
  body: BackendProjectFileRequestDto;
}

export function projectsProjectFilesUpdate(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsProjectFilesUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProjectFileDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectFilesUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProjectFileDto>;
    }),
  );
}

projectsProjectFilesUpdate.PATH = '/api/projects/project/files/{id}/';
